<template>
    <ul class="leftList">
        <li
        v-for="(item,index) in leftlist"
        :key="index"
        :class="[{active: leftActiveIndex == index},'hml_daj']"
        @click="setLeftActiveIndex(index)"
        >
            <img :src="leftActiveIndex == index?item.url2:item.url1">
        </li>
    </ul>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// const publicData = createNamespacedHelpers("publicData");
const mapData = createNamespacedHelpers("mapData");
export default {
    data() { 
        return {}
    },
    methods: {
        ...mapData.mapMutations(["setLeftActiveIndex"])
    }, 
    computed: {
        ...mapData.mapState(['leftActiveIndex',"leftlist"])
    }
}
</script>

<style lang="scss" scoped>
.leftList{
    width: .9rem;
    height: 2.72rem;
    background: #fff;
    border-radius: .1rem;
    box-shadow: 0rem .08rem .08rem 0rem rgba(50,50,50,0.2);
    position: absolute;
    left: .3rem;
    bottom: 2.31rem;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: space-between;
    li{
        width: .9rem;
        height: 100%;
        border-bottom: .01rem solid #eee;
        font-size: .24rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: .4rem;
            height: .4rem;
        }
        &.active{
            color: #0fc;
        }
        &:last-of-type{
            border: 0;
        }
    }
}
</style>